var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSparklesSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.89 9.078c-3.117 1.05-4.144 2.22-4.904 5.133-.76-2.913-1.788-4.083-4.905-5.133 3.117-1.05 4.145-2.22 4.905-5.134.76 2.914 1.787 4.083 4.905 5.134M14.758 4.218c-1.759.59-2.338 1.247-2.767 2.884-.429-1.637-1.009-2.294-2.767-2.884 1.758-.59 2.338-1.248 2.767-2.885.429 1.638 1.008 2.294 2.767 2.885M14.986 12.726c-1.301.428-1.73.904-2.047 2.09-.318-1.186-.747-1.662-2.048-2.09 1.3-.427 1.73-.904 2.048-2.09.317 1.187.746 1.663 2.047 2.09"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.89 9.078c-3.117 1.05-4.144 2.22-4.904 5.133-.76-2.913-1.788-4.083-4.905-5.133 3.117-1.05 4.145-2.22 4.905-5.134.76 2.914 1.787 4.083 4.905 5.134M14.758 4.218c-1.759.59-2.338 1.247-2.767 2.884-.429-1.637-1.009-2.294-2.767-2.884 1.758-.59 2.338-1.248 2.767-2.885.429 1.638 1.008 2.294 2.767 2.885M14.986 12.726c-1.301.428-1.73.904-2.047 2.09-.318-1.186-.747-1.662-2.048-2.09 1.3-.427 1.73-.904 2.048-2.09.317 1.187.746 1.663 2.047 2.09"
  })));
});
export default SvgIconSparklesSolid;
export const raw = __webpack_public_path__ + "static/media/IconSparklesSolid.e785937ade334cb2c4c7ef7dfe8f3f86.svg";